<template>
  <div>
    <div class="container-desktop">
      <transition :name="transitionLeft">
        <div v-if="visible" class="banner-left" @click="visible=false">
          <img :src="bannerLeftSrc" :srcset="bannerLeftSrcSet">
        </div>
      </transition>
      <transition :name="transitionRight">
        <div v-if="visible" class="banner-right" @click="visible=false">
          <img :src="bannerRightSrc" :srcset="bannerRightSrcSet">
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import Boot from '@/Boot';
  import detect from 'detect-browser';

  export default {
    name: "landing-page-banner",
    data() {
      return {
        visible: false,
        bannerLeftSrc: `/static/images/banner-l-${Boot.bannerId}.jpg`,
        bannerLeftSrcSet: `/static/images/banner-l-${Boot.bannerId}@2x.jpg`,
        bannerRightSrc: `/static/images/banner-r-${Boot.bannerId}.jpg`,
        bannerRightSrcSet: `/static/images/banner-r-${Boot.bannerId}@2x.jpg`,
        transitionLeft: detect.detect().name == 'ie' ? 'banner-ie' : 'banner-left',
        transitionRight: detect.detect().name == 'ie' ? 'banner-ie' : 'banner-right'
      }
    },
    created() {

    },
    mounted() {
      const check = () => {
        const bounds = this.$parent.$el.getBoundingClientRect();
        this.visible = bounds.top + bounds.height * 0.3 < window.innerHeight;
        if (!this.visible) {
          this.rafId = requestAnimationFrame(check);
        }
      };
      this.rafId = requestAnimationFrame(check);
    }
  }
</script>

<style lang="scss" scoped>
  .container-desktop {
    position: absolute;
    left: 0px;
    width: 100%;
    z-index: 1;
    margin-top: 8vw;

  }

  .banner-left {
    position: absolute;
    width: 25vw;
    left:10px;
    /*float: left;*/
    /*margin-left: 0px;*/
    max-width: 290px;
    cursor: pointer;
    /*background-color: yellow;*/
    /*height:100px;*/
  }

  .banner-left img {
    width: 100%
  }

  .banner-right {
    position: absolute;
    width: 25vw;
    /*float: right;*/
    right:0px;
    /*margin-right: 0px;*/
    max-width: 290px;
    cursor: pointer;
    /*background-color: yellow;*/
    /*height: 100px;*/
  }

  .banner-right img {
    width: 100%
  }

  $time: 0.5s;

  .banner-left-enter-active, .banner-left-leave-active {
    transition: left $time ease-out;
  }

  .banner-left-enter, .banner-left-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    left: -25vw;
  }

  .banner-right-enter-active, .banner-right-leave-active {
    transition: right $time ease-out;
  }

  .banner-right-enter, .banner-right-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    right: -25vw;
  }

  .banner-ie-enter-active, .banner-ie-leave-active {
    transition: opacity $time * 2 ease-out;
  }

  .banner-ie-enter, .banner-ie-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/LandingPageBanner.vue